import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';
import { DEFAULT_SHAPE } from '../../../constants';

const WindowShape = ({ value, onChange, id='WindowShape', label = 'Window Shape:', disabled = false, showPics = false, disabledOptions = [] }) => {
    const [selectedWindowShape, setSelectedWindowShape] = useState(value || DEFAULT_SHAPE);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setSelectedWindowShape(value || "");
    }, [value]);

    const handleWindowShapeChange = (e) => {
        setSelectedWindowShape(e.target.value);
        onChange(e.target.value);
    };

    const isOptionDisabled = (optionValue) => {
        return disabledOptions.includes(optionValue);
    };

    return (
        <div className="a-container">
            <label htmlFor="WindowShape" disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedWindowShape}
                onChange={handleWindowShapeChange}
            >
                {/*<option value="None">{selectedWindowShape === "None" ? "None ✔" : "None"}</option>*/}
                <option value="Rectangle" disabled={isOptionDisabled("Rectangle")}>{selectedWindowShape === "Rectangle" ? "Rectangle ✔" : "Rectangle"}</option>
                <option value="Triangle Left" disabled={isOptionDisabled("Triangle Left")}>{selectedWindowShape === "Triangle Left" ? "Triangle Left ✔" : "Triangle Left"}</option>
                <option value="Triangle Right" disabled={isOptionDisabled("Triangle Right")}>{selectedWindowShape === "Triangle Right" ? "Triangle Right ✔" : "Triangle Right"}</option>
                <option value="Triangle Center" disabled={isOptionDisabled("Triangle Center")}>{selectedWindowShape === "Triangle Center" ? "Triangle Center ✔" : "Triangle Center"}</option>

                <option value="Trapezoid Left" disabled={isOptionDisabled("Trapezoid Left")}>{selectedWindowShape === "Trapezoid Left" ? "Trapezoid Left ✔" : "Trapezoid Left"}</option>
                <option value="Trapezoid Right" disabled={isOptionDisabled("Trapezoid Right")}>{selectedWindowShape === "Trapezoid Right" ? "Trapezoid Right ✔" : "Trapezoid Right"}</option>

                <option value="AngledTopTrapezoid Left" disabled={isOptionDisabled("AngledTopTrapezoid Left")}>{selectedWindowShape === "AngledTopTrapezoid Left" ? "AngledTopTrapezoid Left ✔" : "AngledTopTrapezoid Left"}</option>
                <option value="AngledTopTrapezoid Right" disabled={isOptionDisabled("AngledTopTrapezoid Right")}>{selectedWindowShape === "AngledTopTrapezoid Right" ? "AngledTopTrapezoid Right ✔" : "AngledTopTrapezoid Right"}</option>

                <option value="Pentagon" disabled={isOptionDisabled("Pentagon")}>{selectedWindowShape === "Pentagon" ? "Pentagon ✔" : "Pentagon"}</option>
                <option value="Octagon" disabled={isOptionDisabled("Octagon")}>{selectedWindowShape === "Octagon" ? "Octagon ✔" : "Octagon"}</option>

                <option value="HalfEyebrow Left" disabled={isOptionDisabled("HalfEyebrow Left")}>{selectedWindowShape === "HalfEyebrow Left" ? "HalfEyebrow Left ✔" : "HalfEyebrow Left"}</option>
                <option value="HalfEyebrow Right" disabled={isOptionDisabled("HalfEyebrow Right")}>{selectedWindowShape === "HalfEyebrow Right" ? "HalfEyebrow Right ✔" : "HalfEyebrow Right"}</option>

                <option value="Eyebrow" disabled={isOptionDisabled("Eyebrow")}>{selectedWindowShape === "Eyebrow" ? "Eyebrow ✔" : "Eyebrow"}</option>

                <option value="Empty Spot" disabled={isOptionDisabled("Empty Spot")}>{selectedWindowShape === "Empty Spot" ? "Empty Spot ✔" : "Empty Spot"}</option>
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/WindowShape"
                imageName={selectedWindowShape}
                width={200}  //optional
                height={250} //optional
            />
        </div>
    );
};

export default WindowShape;
